import React from "react";
export const CashEquivalentData = [
    {
        title: (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Cash Equivalent"))),
        eventKey: "casheq-1",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "(Clear Cash Balance + Pay-In amount + Notional Cash) - Pay-Out amount"))),
    },
    {
        title: (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Clear Cash Balance"))),
        eventKey: "casheq-2",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Cash Available at the beginning of the day"))),
    },
    {
        title: (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Pay-In Amount"))),
        eventKey: "casheq-3",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Funds transferred to your trading account using online funds transfer facility"))),
    },
    {
        title: (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Notional Cash"))),
        eventKey: "casheq-4",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Notional Cash is the limit that will be credited by the next trading day and can be used for trading. Notional Cash can be used for placing a buy order and not for a Pay-out request"))),
    },
    {
        title: (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Pay-Out Amount"))),
        eventKey: "casheq-5",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Pay-out is the amount which was utilized for the day. If the bank account linked to the trading account that has the NEFT facility enabled, then any payout placed before 5 PM will be processed on the next trading days. However, kindly note that payout request are subject to availability of clear funds in your trading account."))),
    },
];
export const Collateral = [
    {
        title: (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Collateral"))),
        eventKey: "Collateral-1",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Limits provided to you against your holdings after applicable haircut"))),
    },
];
export const MarginUtilized = [
    {
        title: (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Margin utilized"))),
        eventKey: "MarginUtilized-1",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Margin amount in the amount utilized by you across all the segments day"))),
    },
    {
        title: (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Realized MTM"))),
        eventKey: "MarginUtilized-2",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Realized MTM is the profit or loss made while squaring off your positions"))),
    },
    {
        title: (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Unrealized MTM"))),
        eventKey: "MarginUtilized-3",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Unrealized MTM is the profit or loss made by your stocks/ contracts which are yet to be squared off"))),
    },
    {
        title: (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Initial Margin = Span Margin + Exposure Margin"))),
        eventKey: "MarginUtilized-4",
        tabContent: (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                React.createElement("strong", null, "Snap Margin:"),
                " it denotes Standardized Portfolio Analysis of Risk. This is the system used by the Exchanges for margin computation Exposure Margin."),
            React.createElement("p", null,
                React.createElement("strong", null, "Exposure Margin:"),
                " it is the margin amount required by Edelweiss on the notional value of positions to be created by the Clients and on existing positions based on the prices of the relevant contract or underlying which is added to arrive at Initial margin"))),
    },
];
export const payinMethods = [
    { value: "IB", display: "Net Banking" },
    { value: "UPI", display: "UPI" },
    { value: "QR", display: "UPI via QR code" },
];
export const FundTransferFilters = [
    {
        filterName: "Transfer Type",
        eventKey: "requestType",
        list: [
            { title: "Pay-In", key: "payin", selected: false },
            { title: "Pay-Out", key: "payout", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: "Transfer Status",
        eventKey: "status",
        list: [
            { title: "Success", key: "Success", selected: false },
            { title: "Failed", key: "Failed", selected: false },
            { title: "Pending", key: "Pending", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: "Payment Mode",
        eventKey: "paymentMode",
        list: [
            { title: "Net Banking", key: "Internet Banking", selected: false },
            { title: "UPI", key: "UPI", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: "Bank",
        eventKey: "bankName",
        list: [
        // { title: "HDFC Bank", key: "HDFC", selected: false },
        // { title: "ICICI Bank ", key: "ICICI", selected: false },
        // { title: "State Bank of India ", key: "State", selected: false },
        // { title: "Bank of Maharashtra ", key: "Maharashtra", selected: false },
        ],
        selectType: "checkbox",
    },
];
export var EFundRoutes;
(function (EFundRoutes) {
    EFundRoutes["ADD_FUNDS"] = "add-funds";
    EFundRoutes["WITHDRAW_FUNDS"] = "withdraw-funds";
    EFundRoutes["TRANSFER_HISTORY"] = "transfer-history";
})(EFundRoutes || (EFundRoutes = {}));
